<template>
    <div class="row px-3">
        <div
            class="algolia-listing-product-block__wrapper"
            v-for="(item, index) in formattedItems"
            :key="index"
            :class="{'col-12 col-md-12': item.isActionBanner || !item.id, 'col-6 col-md-12': item.id && !item.isActionBanner}"
        >

            <HitItem
                v-if="item.id && !item.isActionBanner"
                :item="item"
                :lang-iso="langIso"
                :page-type="pageType"
                @algoliaEvent="sendClickEvent($event, item)"
            />
            <ActionBanner
                v-else-if="item.isActionBanner"
                :action-banner="item"
            />
        </div>
    </div>
</template>

<script>
import HitItem from "./HitItem";
import ActionBanner from "./ActionBanner";

export default {
    name: "HitItems",
    components: {
        HitItem,
        ActionBanner,
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        pageType: {
            type: String,
            required: true
        },
        langIso: {
            type: String,
            required: false,
            default: "nl-NL"
        },
        actionBanners: {
            type: Array,
            required: false,
            default: () => [],
        }
    },
    computed: {
        formattedItems() {
            let newItems = [];
            this.items.forEach((item, index) => {
                newItems.push(item);

                let shouldPushIntoItem = this.isAllowedToDisplayActionBanner(index, this.actionBanners, 5);

                if (shouldPushIntoItem) {

                    let actionBanner = this.isAllowedToDisplayActionBanner(index, this.actionBanners, 5, 1);
                    if (actionBanner) {
                        newItems.push({ ...actionBanner, isActionBanner: true })
                    }

                }
            });

            return newItems;
        },
    },
    methods: {
        sendClickEvent(title, item) {
            // this.$emit('algoliaEvent', { title, item});
        },
        isAllowedToDisplayActionBanner(index, actionBanners , amountOfItems, type = 0) {
            if (((index + 1) % amountOfItems) === 0 && type === 0) {
                return true;
            }

            return actionBanners[(index + 1) - amountOfItems];
        },
    }
};
</script>
